var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { apolloSpaceInset2X, apolloSpaceInset3X } from "@nexthink/apollo-tokens";
import styled from "styled-components";
const StyledDialogHeader = styled.div.withConfig({ displayName: "StyledDialogHeader_APC-7311-productShell", componentId: "sc-inl6n0" })(({ theme, hasLeftSection }) => ({
    position: "relative",
    borderBottom: hasLeftSection ? `1px solid ${theme.colors.apolloColorStrokeSeparator}` : "none",
    padding: hasLeftSection ? apolloSpaceInset2X : `${apolloSpaceInset3X} ${apolloSpaceInset3X} 0`,
}));
const DialogHeader = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (React.createElement(StyledDialogHeader, Object.assign({}, rest), children));
};
export default DialogHeader;
//# sourceMappingURL=DialogHeader.js.map